module.exports = __webpack_public_path__ + "img/details-government.png?1f12cae51f1641dbe5b0887139869d02";